"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DuplicateField;

var _CircularProgress2 = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _FormControlLabel2 = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

var _Switch = _interopRequireDefault(require("../components/Switch"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

DuplicateField.propTypes = {
  type: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  onSave: _propTypes["default"].func,
  column: _propTypes["default"].object
};

function DuplicateField(_ref) {
  var _ref$column = _ref.column,
      column = _ref$column === void 0 ? {} : _ref$column,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      includeData = _useState4[0],
      setIncludeData = _useState4[1];

  function handleSave() {
    return _handleSave.apply(this, arguments);
  }

  function _handleSave() {
    _handleSave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              _context.next = 4;
              return column.onSave({
                includeData: includeData,
                id: column.id
              }, column, "duplicate");

            case 4:
              setLoading(false);
              onClose();
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              setLoading(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));
    return _handleSave.apply(this, arguments);
  }

  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      minWidth: 300
    },
    px: 2,
    pb: 2,
    pt: 1
  }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    variant: "h6"
  }, "Duplicate Field"), /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, /*#__PURE__*/_react["default"].createElement(_FormControlLabel2["default"], {
    style: {
      marginLeft: 0
    },
    control: /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
      checked: includeData,
      onChange: function onChange(e) {
        return setIncludeData(e.target.checked);
      }
    }),
    label: /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, "Include data")
  })), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mt: 2,
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "text",
    size: "small",
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mr: 1
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    variant: "contained",
    size: "small",
    onClick: handleSave,
    disabled: loading,
    autoFocus: true
  }, loading ? /*#__PURE__*/_react["default"].createElement(_CircularProgress2["default"], {
    color: "inherit",
    size: 16
  }) : "Duplicate")));
}